var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGreenUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.7 6.673a.948.948 0 01-.274-.7c0-.283.091-.516.275-.7l4.6-4.6c.1-.1.208-.17.325-.213.116-.04.241-.062.375-.062.133 0 .258.021.375.062A.883.883 0 016.7.673l4.625 4.625a.918.918 0 01.275.675c0 .267-.1.5-.3.7a.948.948 0 01-.7.275.948.948 0 01-.7-.275L6 2.773 2.076 6.698a.918.918 0 01-.675.275.96.96 0 01-.7-.3z",
    fill: "#02B7B0"
  })));
}

export default SvgIconGreenUpArrow;